import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
} from "antd"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { CloseOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons"
import Upload, { RcFile } from "antd/lib/upload"
import styles from "../filing.module.css"
import axios from "axios"
import {
  selectCredentials,
  selectTenantName,
} from "../../../app/applicationSlice"
import { selectTenant } from "../../user/setting/settingSlice"
import moment from "moment"
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnly,
} from "../../../models/datetime"
import { AXIOS_IP, beforeUploadFile, beforeUploadFileAndImage, customRequest, downloadFile } from "../fileUploadService"
import { PreviewImgOrPdf } from "../Preview"

export const YZBAFormModal = (props: {
  visible: boolean
  token: string
  againId?: string
  memo?: string
  onOk: () => void
  onCancel: () => void
}) => {
  const { TextArea } = Input

  const { RangePicker } = DatePicker

  const credentials: any = useSelector(selectCredentials)

  const [form] = Form.useForm()

  const [submitVisible, setSubmitVisible] = useState(false)

  const [fileYZUrl, setfileYZUrl] = useState<any>([]) //义诊说明情况
  const [fileZRUrl, setfileZRUrl] = useState<any>([]) //责任承诺书
  const [fileZZUrl, setfileZZUrl] = useState<any>([]) //资质复印件
  const [fileMDUrl, setfileMDUrl] = useState<any>([]) //义务人员名单
  const [fileCGUrl, setfileCGUrl] = useState<any>([]) //城管部门同意书

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [previewFile, setPreviewFile] = useState<any>() //预览

  //义诊情况参考模板
  const templateQKData = {
    fileConfigId: "5",
    fileName: "义诊情况说明模板",
    fileType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    filePath: "2b548b9d972d876ff7210d6f3c99a727a72408224e5b90d6be8665d521df50d5.docx",
  }

  //义诊活动参考模板
  const templateHDData = {
    fileConfigId: "5",
    fileName: "义诊活动责任承诺书模板",
    fileType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    filePath: "b03147a4f70fe18dabb4acb6397ea30ab6f47259bb5825c2a1e4f8c10e9bd27a.docx",
  }

  // 自定义上传实现
  const customRequestFn = (options: any, type: string) => {
    customRequest(options, AXIOS_IP, (data: any) => {
      const newurl = {
        fileConfigId: data?.configId,
        fileName: data?.name,
        fileType: data?.type,
        filePath: data?.path,
      }
      switch (type) {
        case "YZ":
          setfileYZUrl([...fileYZUrl, newurl])
          break
        case "ZR":
          setfileZRUrl([...fileZRUrl, newurl])
          break
        case "ZZ":
          setfileZZUrl([...fileZZUrl, newurl])
          break
        case "MD":
          setfileMDUrl([...fileMDUrl, newurl])
          break
        case "CG":
          setfileCGUrl([...fileCGUrl, newurl])
          break
      }
    })
  }

  const handleRemove = (type: string, index: number) => {
    switch (type) {
      case "YZ":
        setfileYZUrl(fileYZUrl?.filter((v: any, i: number) => i !== index))
        break
      case "ZR":
        setfileZRUrl(fileZRUrl?.filter((v: any, i: number) => i !== index))
        break
      case "ZZ":
        setfileZZUrl(fileZZUrl?.filter((v: any, i: number) => i !== index))
        break
      case "MD":
        setfileMDUrl(fileMDUrl?.filter((v: any, i: number) => i !== index))
        break
      case "CG":
        setfileCGUrl(fileCGUrl?.filter((v: any, i: number) => i !== index))
        break
    }
  }

  useEffect(() => {
    form.setFieldsValue({
      situationDescriptionFile: fileYZUrl,
    })
  }, [fileYZUrl])

  useEffect(() => {
    form.setFieldsValue({
      responsibilityCommitmentFile: fileZRUrl,
    })
  }, [fileZRUrl])

  useEffect(() => {
    form.setFieldsValue({
      qualificationCopyFile: fileZZUrl,
    })
  }, [fileZZUrl])

  useEffect(() => {
    form.setFieldsValue({
      institutionalCertificationFile: fileMDUrl,
    })
  }, [fileMDUrl])

  useEffect(() => {
    form.setFieldsValue({
      urbanManagementApprovalFile: fileCGUrl,
    })
  }, [fileCGUrl])

  useEffect(() => {
    if (!props.visible) {
      form.resetFields()
      setfileYZUrl([])
      setfileZRUrl([])
      setfileZZUrl([])
      setfileMDUrl([])
      setfileCGUrl([])
    } else {
      if (props.againId) {
        axios({
          url: `${AXIOS_IP}/filingReviewFreeClinic/detail`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": props.token,
          },
          withCredentials: false,
          method: "POST",
          data: { id: props.againId },
        }).then((res) => {
          if (res.data.data) {
            const data = res.data.data
            form.setFieldsValue({ 
              ...data,
              time: [moment(data.startTime), moment(data.endTime)]
            })
            setfileYZUrl(data?.situationDescriptionFile || [])
            setfileZRUrl(data?.responsibilityCommitmentFile || [])
            setfileZZUrl(data?.qualificationCopyFile || [])
            setfileMDUrl(data?.institutionalCertificationFile || [])
            setfileCGUrl(data?.urbanManagementApprovalFile || [])
          }
        }).catch((err) => { console.error(err) })
      }
    }
  }, [props.visible])

  return (
    <>
      <Modal
        title="义诊备案"
        width={1000}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={form.submit}
        okText="提交"
        centered
        maskClosable={false}
      >
        <div>
          <Form
            form={form}
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            style={{ paddingRight: 10 }}
            onFinish={(vs) => {
              setSubmitVisible(true)
            }}
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  name="time"
                  label="义诊时间"
                  rules={[{ required: true }]}
                >
                  <RangePicker
                    format={DateTimeFormatSimpleOnly}
                    style={{ width: "50%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="location"
                  label="义诊地点"
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="content"
                  label="义诊内容"
                  rules={[{ required: true }]}
                >
                  <TextArea allowClear showCount maxLength={500} />
                </Form.Item>
              </Col>
              <Col span={24} className={styles.fileUploadLabel}>
                <Form.Item
                  label="义诊情况说明"
                  name="situationDescriptionFile"
                  rules={[{ required: true, message: "请上传义诊情况说明" }]}
                >
                  <Row align="middle">
                    <Col span={24} style={{ marginBottom: 10 }}>
                      包括义诊的组织单位，开展义诊的时间、地点，义诊的内容，参加的医疗、预防、保健机构名称、医务人员数量及其从事专业等。文件格式为加盖公章的pdf版和图片上传。
                      <a
                        style={{
                          textDecoration: "underline",
                          paddingRight: 10,
                        }}
                        onClick={() => downloadFile(templateQKData, props.token, 'docx')}
                      >
                        参考模板
                      </a>
                    </Col>
                    <Upload
                      customRequest={(options) =>
                        customRequestFn(options, "YZ")
                      }
                      beforeUpload={(file) => beforeUploadFileAndImage(file, fileYZUrl)}
                      showUploadList={false}
                      maxCount={3}
                      accept={".pdf,.jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    {fileYZUrl?.length > 0 &&
                      fileYZUrl?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingLeft: 10,
                            }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a
                                style={{ paddingLeft: 10 }}
                                onClick={() => setPreviewFile(v)}
                              >
                                查看
                              </a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("YZ", index)
                              }}
                            />
                          </div>
                        )
                      })}
                  </Row>
                </Form.Item>
              </Col>
              <Col span={24} className={styles.fileUploadLabel}>
                <Form.Item
                  label="责任承诺书"
                  name="responsibilityCommitmentFile"
                  rules={[{ required: true, message: "请上传责任承诺书" }]}
                >
                  <Row align="middle">
                    <Col span={24} style={{ marginBottom: 10 }}>
                      包括：在预定时间、地点开展所备案的义诊、义诊中不从事商业活动，不误导、欺骗公众，不聘请、雇佣非医务人员提供医疗、预防、保健咨询，不妨碍公共秩序等。文件格式为加盖公章的pdf和图片上传。
                      <a
                        style={{
                          textDecoration: "underline",
                          paddingRight: 10,
                        }}
                        onClick={() => downloadFile(templateHDData, props.token, 'docx')}
                      >
                        参考模板
                      </a>
                    </Col>
                    <Upload
                      customRequest={(options) =>
                        customRequestFn(options, "ZR")
                      }
                      beforeUpload={(file) => beforeUploadFileAndImage(file, fileZRUrl)}
                      showUploadList={false}
                      maxCount={3}
                      accept={".pdf,.jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    {fileZRUrl?.length > 0 &&
                      fileZRUrl?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingLeft: 10,
                            }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a
                                style={{ paddingLeft: 10 }}
                                onClick={() => setPreviewFile(v)}
                              >
                                查看
                              </a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("ZR", index)
                              }}
                            />
                          </div>
                        )
                      })}
                  </Row>
                </Form.Item>
              </Col>
              <Col span={24} className={styles.fileUploadLabel}>
                <Form.Item
                  label="资质复印件"
                  name="qualificationCopyFile"
                  rules={[{ required: true, message: "请上传资质复印件" }]}
                >
                  <Row align="middle">
                    <Col span={24} style={{ marginBottom: 10 }}>
                      《医疗机构执业许可证》复印件或卫生行政部门批准设置的有效证明复印件。支持pdf和图片文件格式上传。
                    </Col>
                    <Upload
                      customRequest={(options) =>
                        customRequestFn(options, "ZZ")
                      }
                      beforeUpload={(file) => beforeUploadFileAndImage(file, fileZZUrl)}
                      showUploadList={false}
                      maxCount={3}
                      accept={".pdf,.jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    {fileZZUrl?.length > 0 &&
                      fileZZUrl?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingLeft: 10,
                            }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a
                                style={{ paddingLeft: 10 }}
                                onClick={() => setPreviewFile(v)}
                              >
                                查看
                              </a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("ZZ", index)
                              }}
                            />
                          </div>
                        )
                      })}
                  </Row>
                </Form.Item>
              </Col>
              <Col span={24} className={styles.fileUploadLabelWrap}>
                <Form.Item
                  label="同意参加义诊证明或参加义诊义务人员名单"
                  name="institutionalCertificationFile"
                >
                  <Row align="middle">
                    <Col span={24} style={{ marginBottom: 10 }}>
                      参加义诊医务人员所在医疗、保健机构出具的同意其参加义诊的证明或参加义诊义务人员名单。支持pdf和图片文件格式上传。
                    </Col>
                    <Upload
                      customRequest={(options) =>
                        customRequestFn(options, "MD")
                      }
                      beforeUpload={(file) => beforeUploadFileAndImage(file, fileMDUrl)}
                      showUploadList={false}
                      maxCount={3}
                      accept={".pdf,.jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    {fileMDUrl?.length > 0 &&
                      fileMDUrl?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingLeft: 10,
                            }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a
                                style={{ paddingLeft: 10 }}
                                onClick={() => setPreviewFile(v)}
                              >
                                查看
                              </a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("MD", index)
                              }}
                            />
                          </div>
                        )
                      })}
                  </Row>
                </Form.Item>
              </Col>
              <Col span={24} className={styles.fileUploadLabel}>
                <Form.Item
                  label="城管部门同意书"
                  name="urbanManagementApprovalFile"
                >
                  <Row align="middle" >
                    <Col span={24} style={{ marginBottom: 10 }}>
                        在城镇公共场所开展义诊需提供城管等部门的同意书。支持pdf和图片文件格式上传。
                    </Col>
                    <Upload
                      customRequest={(options) =>
                        customRequestFn(options, "CG")
                      }
                      beforeUpload={(file) => beforeUploadFileAndImage(file, fileCGUrl)}
                      showUploadList={false}
                      maxCount={3}
                      accept={".pdf,.jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    {fileCGUrl?.length > 0 &&
                      fileCGUrl?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingLeft: 10,
                            }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a
                                style={{ paddingLeft: 10 }}
                                onClick={() => setPreviewFile(v)}
                              >
                                查看
                              </a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("CG", index)
                              }}
                            />
                          </div>
                        )
                      })}
                  </Row>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>

      <Modal
        title="提交申请"
        width={450}
        visible={submitVisible}
        onCancel={() => setSubmitVisible(false)}
        confirmLoading={confirmLoading}
        onOk={() => {
          setConfirmLoading(true)
          const time = form.getFieldValue('time')
          const data = {
            ...form.getFieldsValue(),
            startTime: moment(time?.[0]).format(DateTimeFormatSimpleOnly),
            endTime: moment(time?.[1]).format(DateTimeFormatSimpleOnly),
            time: undefined,
            applicantUserId: credentials.userId,
            applicantUserName: credentials.userName,
            applicantFile: fileYZUrl,
            id: props.againId,
            memo: props.memo,
          }
          axios({
            url: `${AXIOS_IP}/filingReviewFreeClinic/createOrUpdate`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": props.token,
            },
            withCredentials: false,
            method: "POST",
            data,
          })
            .then((res) => {
              if (res.data?.data || res.data?.success) {
                setSubmitVisible(false)
                notification.success({
                  message: "操作成功",
                })
                props.onOk()
              } else {
                notification.error({
                  message: res.data?.msg || "操作失败，请稍后重试",
                })
              }
            })
            .catch(() => {
              notification.error({
                message: "请求异常，请稍后重试",
              })
            })
            .finally(() => {
              setConfirmLoading(false)
            })
        }}
        okText="确认提交"
        centered
        maskClosable={false}
      >
        <Row style={{ height: 50 }}>
          提交后请耐心等待工作人员审核
        </Row>
      </Modal>

      <PreviewImgOrPdf
        token={props.token}
        AXIOS_IP={AXIOS_IP}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
